"use client"
import { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/navigation'
import { useDebounce } from 'use-debounce'
import { Search } from 'lucide-react'

export default function SearchInput({ search }) {
  const router = useRouter()
  const initialRender = useRef(true)

  const [text, setText] = useState(search)
  const [query] = useDebounce(text, 300)

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false
      return
    }

    if (!query) {
      router.push(`/`)
    } else {
      router.push(`/products?search=${query}`);
    }
  }, [query])

  return (
    <div className="group bg-brand-light/60 flex border-2 max-md:order-1 border-transparent focus-within:border-brand-sky focus-within:bg-white px-4 rounded-xl h-10 md:h-[44px] lg:w-2/4 max-md:w-full transition-all duration-200 shadow-brand-sm focus-within:shadow-brand">
      <Search className="text-muted-foreground group-focus-within:text-brand-sky mt-2 mr-2 transition-colors" />
      <input
        type="text"
        placeholder="Search Authors, Books, Electronics etc."
        value={text}
        onChange={e => setText(e.target.value)}
        className="w-full !outline-none !border-none focus:!outline-none focus:!ring-0 bg-transparent text-brand-navy placeholder:text-muted-foreground text-sm"
      />
    </div>
  );
}